import React from "react"
import favicon from "../images/favicon.ico"
export const SEO = props => {
  const { children, pageContext, location } = props
  const { languageCode } = pageContext.layoutContext
  let url = `https://yaytext.com${location.pathname}`
  return (
    <>
      <link rel="shortcut icon" href={favicon} />
      <meta name="theme-color" content="#55B2BF" />
      <meta property="og:site_name" content="YayText!" />
      <meta property="og:type" content="article" />
      <meta property="fb:admins" content="599046014" />
      <meta property="fb:app_id" content="668843993240514" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@yaytext" />
      <meta name="twitter:creator" content="@yaytext" />
      <meta property="og:url" content={url} />
      {!props.disable_link_rel && <link rel="canonical" href={url} />}
      <html lang={languageCode || "en"} />
      {!props.disable_link_rel &&
        props.translatedLinks
          .filter(t => {
            return t.code !== languageCode
          })
          .map(t => {
            return (
              <link
                key={`link_alternate_${t.code}`}
                rel="alternate"
                hrefLang={t.code}
                href={`https://yaytext.com${t.link}`}
              />
            )
          })}
      {children}
    </>
  )
}
